module.exports = __webpack_public_path__ + "img/security_on.15426b3c.svg";